module.exports = __webpack_public_path__ + "static/Secure-da9f4a83645a345a07bcf5f2d4042e74.png";